export const checkReducer = (state = false, action) => {
  switch (action.type) {
    case "checked":
      return action.payload;
    default:
      return state;
  }
};
